module.exports = __webpack_public_path__ + "media/images/about/4-21b71c03e835203958ff642b9fe966ed.jpg";